module.exports = {
	widthStageLeft: '250px',
};
